var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.29329C2 8.29671 2.89424 7.48883 3.99733 7.48883H6.28488C6.75213 7.48883 7.20459 7.34083 7.56354 7.07059L11.362 4.21084C12.0125 3.72113 13 4.13901 13 4.90396V19.096C13 19.861 12.0125 20.2789 11.362 19.7892L7.56354 16.9294C7.20459 16.6592 6.75213 16.5112 6.28488 16.5112H3.99733C2.89423 16.5112 2 15.7033 2 14.7067V9.29329Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4478 9.97C14.4478 9.54957 14.7886 9.20874 15.2089 9.20874C16.7504 9.20874 18 10.4584 18 12C18 13.5416 16.7504 14.7913 15.2089 14.7913C14.7886 14.7913 14.4478 14.4505 14.4478 14.0301C14.4478 13.6096 14.7886 13.2688 15.2089 13.2688C15.9096 13.2688 16.4776 12.7008 16.4776 12C16.4776 11.2993 15.9096 10.7313 15.2089 10.7313C14.7886 10.7313 14.4478 10.3904 14.4478 9.97Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeLow);
export default __webpack_public_path__ + "static/media/volume-low.94a265c520441744d3bbda1271b33433.svg";
export { ForwardRef as ReactComponent };